// Levi preferred-name resolver · Phase 7 correction package.
//
// Single source of truth for how Levi addresses the contractor.
// Falls back through the following order:
//   1. user.levi_preferences.preferred_name_effective (server-computed)
//   2. user.levi_preferred_name  (raw preference, pre /auth/me)
//   3. first token of user.full_name
//   4. empty string
//
// Every Levi-facing surface — drawer greeting, primary hero, Levi
// dashboard greeting — reads from here so the preferred name is
// respected consistently. Non-Levi surfaces (contracts, invoices,
// customer records) MUST continue reading `full_name` directly.

export const leviPreferredName = (user) => {
  if (!user || typeof user !== "object") return "";
  const prefs = user.levi_preferences;
  if (prefs && typeof prefs === "object"
      && typeof prefs.preferred_name_effective === "string"
      && prefs.preferred_name_effective.trim()) {
    return prefs.preferred_name_effective.trim();
  }
  if (typeof user.levi_preferred_name === "string"
      && user.levi_preferred_name.trim()) {
    return user.levi_preferred_name.trim();
  }
  const full = typeof user.full_name === "string" ? user.full_name.trim() : "";
  if (full) return full.split(/\s+/)[0];
  return "";
};
